import {
    getMerchants,
    addMerchants,
    updateMerchants,
    merchantsDocData,
    fetchMerchantsById,
    getMerchantCount
  } from "../../services/MerchantService";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const MERCHANT_LIST_INITIATED = "MERCHANT_LIST_INITIATED";
  export const MERCHANT_INITIATED = "MERCHANT_INITIATED";
  export const MERCHANT_LIST_LOADED = "MERCHANT_LIST_LOADED";
  export const MERCHANT_LOADED = "MERCHANT_LOADED";
  export const MERCHANT_FAILED = "MERCHANT_FAILED";
  export const MERCHANT_COUNT_INITIATED = "MERCHANT_COUNT_INITIATED";
  export const MERCHANT_COUNT_LOADED = "MERCHANT_COUNT_LOADED";
  export const MERCHANT_COUNT_FAILED  = "MERCHANT_COUNT_FAILED";
  export const MERCHANT_DOC_INITIATED = "MERCHANT_DOC_INITIATED";
  export const MERCHANT_DOC_LOADED = "MERCHANT_DOC_LOADED";
  export const MERCHANT_DOC_FAILED  = "MERCHANT_DOC_FAILED";
  export const MERCHANT_NAMELIST_INITIATED = "MERCHANT_NAMELIST_INITIATED";
  export const MERCHANT_NAMELIST_LOADED = "MERCHANT_NAMELIST_LOADED";
  export const MERCHANT_NAMELIST_FAILED  = "MERCHANT_NAMELIST_FAILED";

  
  export const loadMerchants = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_LIST_INITIATED });
      getMerchants(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantsCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_COUNT_INITIATED });
      getMerchantCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getMerchantsById = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_INITIATED });
      return fetchMerchantsById(id)
        .then((response) => {
          dispatch({ type: MERCHANT_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_FAILED, payload: formatError(error) });
        });
    };
  };

  export const getMerchantDocDeatils = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_DOC_INITIATED });
      return merchantsDocData(id)
        .then((response) => {
          dispatch({ type: MERCHANT_DOC_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_DOC_FAILED, payload: formatError(error) });
        });
    };
  };

  
  export const saveMerchantsAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_INITIATED });
      const apiCall = isEdit ? updateMerchants(id, data) : addMerchants(data);
      return apiCall
        .then((response) => {
          formatSuccess('Merchant', response.data)
          if(!isEdit){
            setTimeout(()=>{
              navigate('/merchants');
            },1000)
          }
          else{
            dispatch(loadMerchants()); // Refresh list after save
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: MERCHANT_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: MERCHANT_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };